import type { LayoutBlock } from '@web-studio/shared-schemas';
import { dynamicCocktailSpotlightDefault } from '../blocks/cocktailSpotlight';
import { drinksListStaticDefault } from '../blocks/drinksList';
import { footerStandardDefault } from '../blocks/footer';
import { heroBarFullBleedDefault } from '../blocks/heroVerticals';
import { navigationBarDefault } from '../blocks/navigationVerticals';
import { privatePartyInquiryFormDefault } from '../blocks/partyInquiry';

/** Bar / recommended — marketplace & design-lab preview. */
export const barRecommendedPage: LayoutBlock[] = [
  { ...navigationBarDefault, displayOrder: 0 },
  { ...heroBarFullBleedDefault, displayOrder: 1 },
  { ...drinksListStaticDefault, displayOrder: 2 },
  { ...dynamicCocktailSpotlightDefault, displayOrder: 3 },
  { ...privatePartyInquiryFormDefault, displayOrder: 4 },
  { ...footerStandardDefault, displayOrder: 99 },
];
